// import React from 'react';
// import { Navigate, Outlet } from 'react-router-dom';
// import { useAuth } from './AuthContext';

// interface ProtectedRouteProps {
//   allowedRoles: Array<'owner' | 'manager'>;
//   redirectTo: string;
// }

// const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles, redirectTo }) => {
//   const { user } = useAuth();
//   if (!user || !allowedRoles.includes(user.role as 'owner' | 'manager')) {
//     return <Navigate to={redirectTo} replace />;
//   }
//   return <Outlet />;
// };

// export default ProtectedRoute;


import React from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { useAuth } from './AuthContext';

interface ProtectedRouteProps {
  allowedRoles: Array<'owner' | 'manager'| 'dining associate' | 'customer'>;
  redirectTo: string;
}

// Parse JWT payload
function parseJwt(token: string): any | null {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(
      decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      )
    );
  } catch {
    return null;
  }
}

function isValidSession(role: string): boolean {
  //const key = `Dinelyt_${role}_session`;
  const raw = localStorage.getItem('Dinelyt_session');
  if (!raw) return false;

  try {
    const session = JSON.parse(raw);
    if (!session.token) return false;

    const payload = parseJwt(session.token);
    const tokenRole =
      (payload?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || payload?.role || '').toLowerCase();

    const exp = payload?.exp;
    const now = Date.now();

    return tokenRole === role && exp * 1000 > now;
  } catch {
    return false;
  }
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles, redirectTo }) => {
  const { user } = useAuth();
  const location = useLocation();
  const params = useParams();

  const role = allowedRoles[0]; // assuming only one role per ProtectedRoute

  let isAuthorized = false;

  // First: check via AuthContext
  if (user && allowedRoles.includes(user.role as any)) {
    isAuthorized = true;
  }

  // Second: fallback to localStorage for session (if AuthContext not loaded yet)
  if (!isAuthorized) {
    isAuthorized = isValidSession(role);
  }

  if (!isAuthorized) {
    // Special redirect handling for customers (retain params for QR routing)
    if (role === 'customer') {
      let loginRoute = '/customer-login';
      if (params.restaurantGuid) loginRoute += `?restaurantGuid=${params.restaurantGuid}`;
      if (params.tableId) loginRoute += `&tableId=${params.tableId}`;
      return <Navigate to={loginRoute} replace />;
    }

    // For owner/manager
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
